'use strict'

module.exports = [
  // Uses ª if gender option is 'female', otherwise º
  { suffix: ({ gender }) => gender && gender.toLowerCase() === 'female' ? 'ª' : 'º' }
]
